import { Button, Modal } from 'react-bootstrap'
import bgrWin from "assets/images/eventBunpimay/brgPopupWin.png"
import bgrFnTop from "assets/images/eventBunpimay/brgPopupFN.png"
import { ModalCloseBunpimaySVG } from 'assets/svg/ModalSVG/ModalCloseBunpimaySVG'

function BaseModalEventBunpimay({
	show,
	onHide,
	onShow,
	children,
	hideDecor,
	srcImgHeader = null,
	classProp = "",
	...otherProps
}) {
	return (
		<Modal
			show={show}
			onHide={onHide}
			{...otherProps}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			className={`modal-base-bunpimay ${classProp}`}
			backdrop={true}
		>
			{children}
			{srcImgHeader ? <img draggable="false" src={srcImgHeader} alt="" className="header-popup" /> : null}
			{hideDecor ? null : (
				<img draggable="false" src={bgrWin} alt="" className="bgr-win" />
			)}
			{hideDecor === 'bgr_FN' ? (
				<img draggable="false" src={bgrFnTop} alt="" className="bgr-win" />
			) : null}
			<Button variant="dark" onClick={onHide} className="btn-close">
				<ModalCloseBunpimaySVG width="32" height="32" viewBox="0 0 32 32" />
			</Button>
		</Modal>
	)
}

export default BaseModalEventBunpimay
